import maps from '../components/maps';

export default {
    init() {
    },
    finalize() {
        maps.finalize();
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact-us.js